import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKid.module.scss";

function PageKid() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p02", "png", s.description);
  const item01 = getImgSet("item__01__p02", "png");
  const item02 = getImgSet("item__02__p02", "png");
  const item03 = getImgSet("item__03__p02", "png");
  const item04 = getImgSet("item__04__p02", "png");
  const pointer = getImgSet("pointer__kid", "png", s.pointer);

  const back = getImgSet("back__p21", "png");
  const imgA = getImgSet("bear__03", "png", s.img__a);
  const imgB = getImgSet("img__p02", "png", s.img__b);
  const quizBtn = getImgSet("button__quiz", "png");

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.header}>{description}</div>
      <div className={s.aside_left}>
        {imgA}
        <Link to="/" className={s.back}>
          {back}
        </Link>
      </div>
      <div className={s.inner}>
        <Link to="a" className={cn(s.item, s.item__01)}>
          {item01}
        </Link>
        <Link to="b" className={cn(s.item, s.item__02)}>
          {item02}
        </Link>
        <Link to="d" className={cn(s.item, s.item__03)}>
          {item03}
        </Link>
        <Link to="f" className={cn(s.item, s.item__04)}>
          {item04}
        </Link>
      </div>
      <div className={s.aside_right}>
        {imgB}
        <Link to="/kid/quiz" className={s.button__quiz}>
          {quizBtn}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutOptions(PageKid);
